<script setup>
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import TemplatesPicker from './TemplatesPicker.vue';
import InstagramTemplateReply from './InstagramTemplateReply.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  inboxId: { type: Number, default: undefined },
});

const emit = defineEmits(['onSend', 'cancel', 'update:show']);

const { t } = useI18n();

const selectedTemplate = ref(null);

const localShow = computed({
  get: () => props.show,
  set: value => emit('update:show', value),
});

const modalHeaderContent = computed(() =>
  selectedTemplate.value
    ? t('INSTAGRAM_TEMPLATES.MODAL.TEMPLATE_SELECTED_SUBTITLE', {
        templateName: selectedTemplate.value.name,
      })
    : t('INSTAGRAM_TEMPLATES.MODAL.SUBTITLE')
);

watch(
  () => props.show,
  value => {
    if (!value) selectedTemplate.value = null;
  }
);
</script>

<template>
  <woot-modal
    v-model:show="localShow"
    :on-close="() => emit('cancel')"
    size="modal-big"
  >
    <woot-modal-header
      :header-title="t('INSTAGRAM_TEMPLATES.MODAL.TITLE')"
      :header-content="modalHeaderContent"
    />
    <div class="px-8 py-6">
      <TemplatesPicker
        v-if="!selectedTemplate"
        :inbox-id="inboxId"
        @on-select="selectedTemplate = $event"
      />
      <InstagramTemplateReply
        v-else
        :template="selectedTemplate"
        @reset-template="selectedTemplate = null"
        @send-message="emit('onSend', $event)"
      />
    </div>
  </woot-modal>
</template>
